import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import useNestedTracksStore from '@/stores/nestedTracksStore'
import clientGetToggleFromCookie from '@/utils/cookies/getToggleFromCookie'

import {
	NESTED_TRACKS_TOGGLE,
	NESTED_TRACKS_TRAY_ID,
} from './NestedTracks.constants'
import { closeNestedTracksTray } from './NestedTracks.utils'

export const useClearNestedTracksStoreOnDialogClose = (): void => {
	useEffect(() => {
		const dialog = document.getElementById(NESTED_TRACKS_TRAY_ID)

		if (!(dialog instanceof HTMLDialogElement)) {
			return
		}

		const handleClose = (): void => {
			useNestedTracksStore.getState().clear()
		}

		dialog.addEventListener('close', handleClose)

		return (): void => {
			dialog.removeEventListener('close', handleClose)
		}
	}, [])
}

export const useCloseNestedTracksTrayOnRouteChange = (): void => {
	const { events } = useRouter()

	useEffect(() => {
		if (!events?.on) {
			return
		}

		const handleRouteChange = (): void => {
			closeNestedTracksTray()
			useNestedTracksStore.getState().clear()
		}

		events.on('routeChangeStart', handleRouteChange)

		return (): void => {
			events.off('routeChangeStart', handleRouteChange)
		}
	}, [events])
}

/** Read after mount so server and first client render agree (toggle lives in a cookie). */
export const useIsNestedTracksEnabled = (): boolean => {
	const [isEnabled, setIsEnabled] = useState(false)

	useEffect(() => {
		setIsEnabled(clientGetToggleFromCookie(NESTED_TRACKS_TOGGLE))
	}, [])

	return isEnabled
}
